export default __webpack_public_path__ + "static/media/icon-explore-white.d78f5573.svg";